
import { Vue, Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import SearchPopup from "../statement/components/SearchPopup.vue";
import CoreData from "./components/CoreData.vue";
import OverviewData from "./components/OverviewData.vue";
import CategoryProportion from "./components/CategoryProportion.vue";
import PaymentMethod from "./components/PaymentMethod.vue";
import GoodsRanking from "./components/GoodsRanking.vue";
import CashReconciliation from "./components/CashReconciliation.vue";
import TransactionDetails from "./components/TransactionDetails.vue";
import MemberAnalysis from "./components/MemberAnalysis.vue";
import SettingCard, { ICard } from "./components/SettingCard.vue";
import { getReportSettingsList, updateAppReportSettings, getMessageCount } from "@/api/shouyin";
import SkeletonCard from "@/components/SkeletonCard/index.vue";
import moment from "moment";
import MultiCoreData from "./components/MultiCoreData.vue";
import ChangeStore from "@/components/ChangeStore/index.vue";
import { setAllowsBackGesture } from "@/utils/h5ToApp";
import getDate from "@/views/company/getDate"
const mapStr = {
  OverviewData: "总览数据", // 总览数据
  CoreData: "核心数据", // 核心数据
  CategoryProportion: "类别占比", // 类别占比
  PaymentMethod: "付款方式", // 付款方式
  GoodsRanking: "商品排行", // 商品排行
  CashReconciliation: "收银对账", // 收银对账
  TransactionDetails: "交易明细", // 交易明细
  MemberAnalysis: "会员分析", // 会员分析
  MultiCoreData: "多店核心", // 多店核心
};

@Component({
  name: 'Workbench',
  components: {
    SearchPopup,
    DimensionSelect,
    CoreData,
    OverviewData,
    CategoryProportion,
    PaymentMethod,
    GoodsRanking,
    CashReconciliation,
    TransactionDetails,
    MemberAnalysis,
    SettingCard,
    SkeletonCard,
    MultiCoreData,
    ChangeStore,
  },
})
export class Workbench extends Vue {
  @Getter companyId!: string;
  @Getter userId!: string;
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;
  @Getter info!: any;

  isInit = false;

  showTotal = true; // 是否显示全览
  dimension = "门店";
  dimensionValue = "1";

  searchRes = null;
  count = 0

  params: Record<string, any> = {};
  headerName = "工作台";

  componentsMap = {
    OverviewData, // 总览数据
    CoreData, // 核心数据
    CategoryProportion, // 类别占比
    PaymentMethod, // 付款方式
    GoodsRanking, //商品排行
    CashReconciliation, //收银对账
    TransactionDetails, // 交易明细
    MemberAnalysis, // 会员分析
    MultiCoreData, // 多店核心
  };

  // 单店需要显示的卡片
  showCardMap: Record<string, string[]> = {
    总览: ["总览数据", "核心数据", "收银对账", "交易明细", "会员分析"],
    门店: [
      "总览数据",
      "核心数据",
      "类别占比",
      "付款方式",
      "商品排行",
      "收银对账",
      "交易明细",
      "会员分析",
    ],
    微店: [
      "总览数据",
      "核心数据",
      "类别占比",
      "付款方式",
      "商品排行",
      "收银对账",
      "交易明细",
      "会员分析",
    ],
  };
  // 多店总览需要显示的卡片
  multiShowCardMap: Record<string, string[]> = {
    总览: ["总览数据", "核心数据", "多店核心"],
    门店: [
      "总览数据",
      "核心数据",
      "类别占比",
      "付款方式",
      "商品排行",
      "多店核心",
    ],
    微店: [
      "总览数据",
      "核心数据",
      "类别占比",
      "付款方式",
      "商品排行",
      "多店核心",
    ],
  };

  resMap = [];
  resMapStr = [];
  cardList: ICard[] = [
    {
      title: "总览数据",
      valueKey: "OverviewData",
      visible: true,
      sortNum: 1,
    },
    {
      title: "核心数据",
      valueKey: "CoreData",
      visible: true,
      sortNum: 2,
    },
    {
      title: "类别占比",
      valueKey: "CategoryProportion",
      visible: false,
      sortNum: 3,
    },
    {
      title: "付款方式",
      valueKey: "PaymentMethod",
      visible: true,
      sortNum: 4,
    },
    {
      title: "商品排行",
      valueKey: "GoodsRanking",
      visible: true,
      sortNum: 5,
    },
    {
      title: "收银对账",
      valueKey: "CashReconciliation",
      visible: false,
      sortNum: 6,
    },
    {
      title: "交易明细",
      valueKey: "TransactionDetails",
      visible: false,
      sortNum: 7,
    },
    {
      title: "会员分析",
      valueKey: "MemberAnalysis",
      visible: false,
      sortNum: 8,
    },
    {
      title: "多店核心",
      valueKey: "MultiCoreData",
      visible: true,
      sortNum: 9,
    },
  ];
  listScrollTop = 0
  // 标记是否从详情页返回（需要保持缓存）
  isFromDetail = false

  handleScroll (event: any) {
    this.listScrollTop = event.target.scrollTop
  }

  // 重置搜索条件为初始状态
  resetSearchParams() {
    this.dimension = "门店";
    this.dimensionValue = "1";
    this.searchRes = {
      endtime: moment().format("YYYY-MM-DD"),
      label: "今天",
      nowTimeText: moment().format("YYYY/MM/DD"),
      starttime: moment().format("YYYY-MM-DD"),
      value: 1
    }
    this.params = {
      queryTimeEnd: `${moment().format("YYYY-MM-DD")} 23:59:59`,
      queryTimeBegin: `${moment().format("YYYY-MM-DD")} 00:00:00`,
      orderType: "1",
      storeId: this.companyId,
    };
    // 清除本地存储的参数
    window.localStorage.removeItem("WorkbenchParams");
  }

  // 3. 缓存生命周期：页面激活（从详情页返回）时触发
  activated() {
    // 从 sessionStorage 获取上一次离开时的目标页面
    const toName = sessionStorage.getItem('workbenchLeaveTo') || ''
    // 详情页
    const detailPages = ['CoreDataDetail', 'GoodsRankingDetail', 'PaymentMethodDetail', 'CategoryProportionDetail', 'TransactionDetail','MemberAnalysisDetail','MessageManage']
    this.isFromDetail = detailPages.includes(toName)
    // 清除记录
    sessionStorage.removeItem('workbenchLeaveTo')
    
    document.querySelector('.flex-scroll') && document.querySelector('.flex-scroll').scrollTo(0, this.listScrollTop)
    // 如果不是从详情页返回，则刷新数据并重置搜索条件
    if (!this.isFromDetail) {
      document.querySelector('.flex-scroll') && document.querySelector('.flex-scroll').scrollTo(0, 0)
      this.resetSearchParams()
      this.getData()
      if (!this.isMultiStore) {
        this.getMessageCount()
      }
    }
  }

  // 缓存生命周期：页面离开时触发
  deactivated() {
    // 记录离开时的目标页面
    const toName = this.$route?.name || ''
    sessionStorage.setItem('workbenchLeaveTo', toName)
  }

  @Watch("dimension")
  @Watch("cardList", { deep: true, immediate: true })
  onCardChange() {
    const mapData = this.isMultiStore
      ? this.multiShowCardMap
      : this.showCardMap;
    const showList = mapData[this.dimension] || "门店";
    this.resMap = this.cardList
      .filter((item) => item.visible)
      .filter((item) => showList.includes(item.title))
      .map((item) => item.valueKey);
    this.resMapStr = this.resMap.map((item) => mapStr[item]);
  }

  @Watch("searchRes")
  onSearchResChange(newVal: any) {
    const { starttime, endtime } = newVal;
    this.params = {
      ...this.params,
      queryTimeBegin: `${starttime} 00:00:00`,
      queryTimeEnd: `${endtime} 23:59:59`,
      orderType: this.dimensionValue,
      storeId: this.companyId,
      timeType: newVal.value,
    };
  }

  // 获取数据
  async getData() {
    this.isInit = false;
    if (!this.userId) {
      this.$toast("请重新登录");
      return;
    }

    const res = await getReportSettingsList({
      storeId: this.isMultiStore ? this.userId : this.companyId, // 多店总览传userId，单店传storeId
    });
    if (res.code === "000000") {
      const list = res.data.map((item) => {
        return {
          ...item,
          visible: item.visible === 1,
        };
      });
      if (!list.find((item) => item.title === "多店核心")) {
        list.push({
          title: "多店核心",
          valueKey: "MultiCoreData",
          visible: true,
          sortNum: 9,
        });
      }

      this.cardList = list;
      this.isInit = true;
    }
  }

  // 时间范围切换确认
  onSearchConfirm(res) {
    this.searchRes = res;
    this.setLocalParams();
  }

  onDimensionConfirm(value: string, orderType: string) {
    this.dimension = value;
    this.dimensionValue = orderType;
    // 设置参数
    this.params = {
      ...this.params,
      orderType: orderType,
    };
    this.setLocalParams();
  }

  setLocalParams() {
    const obj = {
      searchRes: this.searchRes,
      dimension: {
        text: this.dimension,
        orderType: this.dimensionValue,
      },
    };
    window.localStorage.setItem("WorkbenchParams", JSON.stringify(obj));
  }

  // 修改排序和隐藏
  async onSettingConfirm(cards: ICard[]) {
    const cardListT = cards.map((i, index) => {
      return {
        sortNum: index + 1,
        visible: i.visible ? 1 : 0,
        title: i.title,
        valueKey: i.valueKey,
      };
    });
    this.cardList = cards;
    const params = {
      storeId: this.userId,
      dataList: cardListT,
    };
    const res = await updateAppReportSettings(params);
    if (res.code === "000000") {
      this.$toast.success("修改成功");
    }
  }

  // 是否禁用侧滑返回
  setAllowsBackGesture(isAllow: boolean) {
    setAllowsBackGesture(isAllow ? "1" : "0");
  }

  // 获取未读消息数量
  async getMessageCount() {
    const res = await getMessageCount({ storeId: this.companyId || 'none'});
    if (res.code === "000000") {
      this.count = res.data.count
    }
  }

  created() {
    if (!this.isMultiStore) {
      this.getMessageCount()
    }
    if (this.isMultiStore) {
      this.headerName = `多店总览${
        this.multiStoreList.length > 0 ? `(${this.multiStoreList.length})` : ""
      }`;
    } else {
      this.headerName = this.info?.storeName || "工作台"; //"店铺名店铺名称店铺名称店铺名称店铺名称称";
    }
    const pObj: Record<string, any> = {
      queryTimeEnd: `${moment().format("YYYY-MM-DD")} 23:59:59`,
      queryTimeBegin: `${moment().format("YYYY-MM-DD")} 00:00:00`,
      orderType: this.dimensionValue,
      storeId: this.companyId,
    };
    const paramsStr = window.localStorage.getItem("WorkbenchParams");
    if (paramsStr && paramsStr !== "") {
      const workbenchParams = JSON.parse(paramsStr);

      if (workbenchParams.searchRes) {
        const searchRes = workbenchParams.searchRes;

        pObj.queryTimeEnd = `${searchRes.endtime} 23:59:59`;
        pObj.queryTimeBegin = `${searchRes.starttime} 00:00:00`;
        this.searchRes = searchRes;
      }
      if (workbenchParams.dimension) {
        pObj.orderType = workbenchParams.dimension.orderType;
        this.dimension = workbenchParams.dimension.text;
        this.dimensionValue = workbenchParams.dimension.orderType;
      }
      this.params = pObj;
      this.setLocalParams();
    }
  }
  mounted() {
    this.getData();
    this.setAllowsBackGesture(false);
  }
  beforeDestroy() {
    console.log("Workbench beforeDestroy");
    this.setAllowsBackGesture(true);
  }

  goMessage() {
    this.$router.push('/messageManage')
    // this.$router.push('/couponManage')
  }
}
export default Workbench;
